import React from 'react'

import Feature, {
  Group as FeatureGroup,
  Item as FeatureItem,
  Desc as FeatureDesc
} from 'components/Feature'
import { useMobile } from 'hooks/ua'

import icon1 from './images/icon1.png'
import icon2 from './images/icon2.png'
import icon3 from './images/icon3.png'

export default function Advantage() {
  const isMobile = useMobile()

  return (
    <Feature name="advantage" title="合作优势" grey={isMobile}>
      <FeatureGroup useDefault={!isMobile}>
        <FeatureItem
          pos="top-down"
          icon={icon1}
          title="业务多元化"
          mobilePos="left-right"
        >
          <FeatureDesc>服务多家互联网头部企业，资源丰富，需求稳定</FeatureDesc>
        </FeatureItem>
        <FeatureItem
          pos="top-down"
          icon={icon2}
          title="多种对接方式"
          mobilePos="left-right"
        >
          <FeatureDesc>可通过 API 方式对接，也支持无代码化接入</FeatureDesc>
        </FeatureItem>
        <FeatureItem
          pos="top-down"
          icon={icon3}
          title="保姆级贴心服务"
          mobilePos="left-right"
          isLast
        >
          <FeatureDesc>提供一对一 VIP 服务，快速响应技术、跑量和结算问题</FeatureDesc>
        </FeatureItem>
      </FeatureGroup>
    </Feature>
  )
}
